import { createSlice } from '@reduxjs/toolkit';
import { EntityStoreName } from 'app/enums/store';

import { initialState } from './adapter';
import {
  clearAllReducer,
  closeAllModalsReducer,
  closeModalReducer,
  closeModalsReducer,
  openModalReducer,
} from './reducers';

export const modalsState = createSlice({
  name: EntityStoreName.Modals,
  initialState,
  reducers: {
    clearAll: clearAllReducer,
    openModal: openModalReducer,
    closeModal: closeModalReducer,
    closeModals: closeModalsReducer,
    closeAllModals: closeAllModalsReducer,
  },
});

export const modalsReducers = { ...modalsState.actions };
